import Vue from 'vue';
import { mapGetters } from 'vuex';
import ProfileSettings from './profile';
import SecuritySettings from './security';
import Billing from './billing';

export default Vue.component('admin-account', {
  template: require('./template.html'),
  name: 'admin-account',
  computed: {
    ...mapGetters(['currentUser']),
    socialUser() {
      let social;
      const identities = this.currentUser.identities;
      if (identities) {
        const list = JSON.parse(identities)[0];
        social = list.providerName;
      }
      return social;
    },
  },
  components: {
    ProfileSettings,
    SecuritySettings,
    Billing,
  },
  data() {
    return {
      border: '#2d2e33',
      tabs: [
        {
          label: 'Profile',
          route: {
            name: 'admin-edit-profile',
            path: '/profile',
          },
        },
        {
          label: 'Security',
          route: {
            name: 'admin-edit-security',
            path: '/security',
          },
        },
      ],
      modals: {
        deleteAccount: false,
        deleteYourself: false,
      },
    };
  },
  created() {
    if (this.currentUser.owner) {
      this.tabs.push({
        label: 'Billing',
        route: {
          name: 'admin-edit-billing',
          path: '/billing',
        },
      });
    }
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/index.js